import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppId, AppThunkAPIType } from "../../../app/appTypes"
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../http"

export interface DocumentVersionHistory {
    id: AppId,
    no: string,
    version: number,
    headDocumentId: number,
    createDate: Date,
    createdBy: string,
    createdByFullName: string,
    status: string,
    type: string,
    isMainDocument: boolean,
    changeLogs: DocumentChangeLog[]
}

export interface DocumentChangeLog {
    id: AppId,
    documentId: AppId,
    changeReason: string,
    changeDescription: string,
    createDate: Date,
    createdBy: string,
    createdByFullName: string,
}

export interface CreateUpdateDocumentChangeLogPayload {
    changeReason: string,
    changeDescription: string
}

export const loadDocumentFullVersionHistory = createAsyncThunk<DocumentVersionHistory[], { documentId: AppId; }, AppThunkAPIType>("document-history/loadDocumentFullVersionHistory",
    async ({ documentId }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/document-history/${documentId}`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as DocumentVersionHistory[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const addDocumentChangeLog = createAsyncThunk<DocumentChangeLog, { documentId: AppId, payload: CreateUpdateDocumentChangeLogPayload }, AppThunkAPIType>("document-history/add-change-log", async (data, { dispatch, rejectWithValue }) => {
    const result = await dispatch(postWithAuth({
        url: `api/document-history/${data.documentId}/changelog`,
        payload: {
            ...data.payload
        },
    }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as DocumentChangeLog
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateDocumentChangeLog = createAsyncThunk<DocumentChangeLog, { documentId: AppId, logId: AppId, payload: CreateUpdateDocumentChangeLogPayload }, AppThunkAPIType>("document-history/update-change-log", async (data, { dispatch, rejectWithValue }) => {
    const result = await dispatch(putWithAuth({
        url: `api/document-history/${data.documentId}/changelog/${data.logId}`,
        payload: {
            ...data.payload
        },
    }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as DocumentChangeLog
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})


export const deleteDocumentChangeLog = createAsyncThunk<AppId, { documentId: AppId, logId: AppId }, AppThunkAPIType>("document-team-member/deleteTeamMember",
    async (data, { dispatch, rejectWithValue }) => {

        const result = await dispatch(deleteWithAuth({
            url: `api/document-history/${data.documentId}/changelog/${data.logId}`,
        }))
        const { payload } = result

        if (deleteWithAuth.fulfilled.match(result)) {
            return data.logId

        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })